//页面图片与icon
export const ImgObj = {
  advance_icon: require("@/assets/imgs/advance_sale_img.png"),
  arrow_right: require("@/assets/imgs/arrow_right.png"),
  listEmpty_img: require("@/assets/imgs/order_list_empty.png"),
  history_default: require("@/assets/imgs/history_default_icon.png"),
  no_search_icon: require("@/assets/imgs/no_search_icon.png"),
  history_select: require("@/assets/imgs/history_select_icon.png"),
  list_empty_img: require("@/assets/imgs/order_list_empty.png"),
  orderlist_time_img: require("@/assets/imgs/order_list_time.png"),
  order_list: require("@/assets/imgs/order_list.png"), //本地测试图
  select_arrow_bottom: require("@/assets/imgs/select_arrow_bottom.png"),
  select_arrow_hover: require("@/assets/imgs/select_arrow_hover.png"),
  location_arrow_top: require("@/assets/imgs/location_top.png"),
  location_arrow_hover: require("@/assets/imgs/location_top_hover.png"),
  input_error_icon: require("@/assets/imgs/input_error.png"),
  right_icon: require("@/assets/imgs/right.png"),
  select_arrow_top: require("@/assets/imgs/select_arrow_top.png"),
  pop_del_icon: require("@/assets/imgs/pop_del_icon.png"),
  confirm_error_img: require("@/assets/imgs/confirm_error_img.png"),
  ticket_icon: require("@/assets/imgs/ticket_way_icon.png"),
  ticket_icon2: require("@/assets/imgs/ticket_icon.png"),
  ziqu_icon: require("@/assets/imgs/ziqu_icon.png"),
  kuaidi_icon: require("@/assets/imgs/kuaidi_icon.png"),
  machine_icon: require("@/assets/imgs/machine_icon.png"),
  ticket_img: require("@/assets/imgs/ticket_way_img.png"),
  card_img: require("@/assets/imgs/card_img.png"),
  card_icon2: require("@/assets/imgs/card_icon.png"),
  user_add: require("@/assets/imgs/user_add.png"),
  address_add: require("@/assets/imgs/address_add.png"),
  user_icon: require("@/assets/imgs/ticket_user.png"),
  view_people: require("@/assets/imgs/view_people.png"),
  address_people: require("@/assets/imgs/address_people.png"),
  ticket_address: require("@/assets/imgs/ticket_address.png"),
  location_address: require("@/assets/imgs/location_address.png"),
  fudou_icon: require("@/assets/imgs/fudou.png"),
  tips_icon: require("@/assets/imgs/tips_error.png"),
  default_delete: require("@/assets/imgs/default_delete.png"),
  default_edit: require("@/assets/imgs/default_edit.png"),
  select_delete: require("@/assets/imgs/select_delete.png"),
  select_edit: require("@/assets/imgs/select_edit.png"),
  del_success: require("@/assets/imgs/del_success.png"),
  advance_sale_icon: require("@/assets/imgs/advance_sale_icon.png"),
  tip_info_icon: require("@/assets/imgs/info.png"),
  ticket_success_icon: require("@/assets/imgs/ticket_success_icon.png"),
  wait_pay: require("@/assets/imgs/wait_pay.png"),
  dongfu_qrcode: require("@/assets/imgs/dongfu_qrcode.png"),
  pay_wait_time: require("@/assets/imgs/pay_wait_time.png"),
  user_add_disabled: require("@/assets/imgs/user_add_disabled.png"),
  address_add_disabled: require("@/assets/imgs/address_add_disabled.png"),
  add_ticket_owner_icon: require("@/assets/imgs/add_ticket_owner_icon.png"),
  confirm_ticket_owner: require("@/assets/imgs/confirm_ticket_owner.png"),
  ticket_mobile_icon: require("@/assets/imgs/ticket_mobile_icon.png"),
  ticket_kuaidi_icon: require("@/assets/imgs/kuaidi_icon.png"),
  shouhuo_icon: require("@/assets/imgs/shouhuodizhi_icon.png"),
  drama_watcher_icon: require("@/assets/imgs/drama_watcher_icon.png"),
  no_data_img: require("@/assets/imgs/no_data.png"),
  isresave_img: require("@/assets/imgs/isresave.png")
};

//订单列表 状态下拉选择数据
export const status_array = [
  { name: "全部状态", id: null },
  { name: "待支付", id: 1 },
  { name: "已支付", id: 2 },
  { name: "出票中", id: 7 },
  { name: "出票成功", id: 8 },
  { name: "已取消", id: 4 },
  { name: "已完成", id: 5 }
];

//确认订单页面 form的表单字段
export const addressRules = {
  name: "",
  location: "",
  address: "",
  mobile: "",
  telPhone: "",
  zipCode: ""
};
export const cardForm = {
  consigneeName: "",
  ownerName: "",
  consigneePhone: "",
  ownerPhone: "",
  ownerIdCardNo: "",
  verificationCode: ""
};
export const cardForm_ticket = {
  consigneeName: "",
  consigneePhone: "",
  ownerIdCardNo: "",
  verificationCode: ""
};
//演出预留手机号 校验
export const mobileRules = {
  phone: [
    { required: true, message: "请输入手机号", trigger: "blur" },
    {
      pattern: /^1\d{10}$/,
      message: "请输入正确的手机号",
      trigger: "blur"
    }
  ],
  code: [
    { required: true, message: "请输入验证码", trigger: "blur" },
    { pattern: /^\d{6}$/, message: "请输入正确的验证码", trigger: "blur" }
  ]
};
